// extracted by mini-css-extract-plugin
export default {"invoiceCard":"styles_invoiceCard__Z6OmK","iconBox":"styles_iconBox__bm3F9","content":"styles_content__PcjPP","group":"styles_group__1RU93"};